// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"244":"a0ae7a91","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"244":"2b377e15a808cc84aa6e","245":"87d6c50efab927dfe89b","453":"13e14cdf315af5cbc3e3"}[chunkId] + ".js";
};